import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

const Step = ({ className, registration, translate, users }) => {
	const classProps = classNames('step', className);
	const adjustedStep = registration.currentStep;

	let title,
		desc,
		titleClass = 'registration-step-header';

	if (window.location.pathname === '/users/connect' && !isEmpty(users.authenticated)) {
		title = translate('ConnectToPoints.header-title_registered');
		desc = translate('ConnectToPoints.header_registered');
		titleClass += ' text-left';
	} else {
		title = `${translate('RegistrationFlow.title')} ${translate('RegistrationFlow.step')} ${adjustedStep}`;
		desc = translate(`RegistrationFlow.steps.items.${adjustedStep}.desc`);
	}

	return (
		<div className={classProps}>
			<h1 className={titleClass}>{title}</h1>
			<p className="text-center">{desc}</p>
		</div>
	);
};

Step.defaultProps = {
	className: ''
};

Step.propTypes = {
	// Required
	registration: PropTypes.object.isRequired,
	translate: PropTypes.func.isRequired,
	users: PropTypes.object.isRequired,

	// Optional
	className: PropTypes.string
};

const mapStateToProps = state => ({
	translate: getTranslate(state.locale),
	users: state.users
});

export default connect(mapStateToProps)(Step);
